module.exports = __webpack_public_path__ + "img/yamp_logo.f10e4cd9.png";